import { render, staticRenderFns } from "./FeatureModal.vue?vue&type=template&id=0cef702c&"
import script from "./FeatureModal.vue?vue&type=script&lang=js&"
export * from "./FeatureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports